<template>
  <div class="container">
    <div style="width: 1260px; margin: 0 auto; display: flex">
      <div class="tab">
        <div class="tab_title">购买</div>
        <!-- <div class="underline"></div> -->
        <ul>
          <li
            v-for="(item, index) in tab_arr"
            :key="index"
            @click="changeTab(item.index)"
            :class="active_index == item.index ? 'active' : ''"
          >
            <span>{{ item.name }}</span>
            <!-- <span v-if="active_index==item.index" style="float:right">></span> -->
          </li>
        </ul>
      </div>
      <div class="content">
        <div v-if="active_index == 0">
            <Buywh8></Buywh8>
        </div>
        <div v-if="active_index == 1">
            <Buywh9></Buywh9>
        </div>
        <div v-if="active_index == 2">
            <Buywh10></Buywh10>
        </div>
        <div v-if="active_index == 3">
            <Buywh12></Buywh12>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Buywh8 from '../components/Buywh8.vue'
import Buywh9 from '../components/Buywh9.vue'
import Buywh10 from '../components/Buywh10.vue'
import Buywh12 from '../components/Buywh12.vue'
import commonData from '../plugins/FetchCommonData'
export default {
  data() {
    return {
      tab_arr: [],
      active_index: 0,
      input: "",
      flag: 0,
      data: {},
    };
  },
  components:{
    Buywh8,Buywh10,Buywh12,Buywh9
  },
  methods: {
    changeTab(index) {
      this.active_index = index;
    },
    goto() {
      var url = this.$router.resolve({ path: "/Service?idx=0" });
      window.open(url.href, "_blank");
    },
    search() {
      axios
        .get(
          "https://Wt9.wenhua.com.cn/api/ServiceApi/GetService?id=" + this.input
        )
        .then((res) => {
          // console.log(res)
          if (res.data.status) {
            this.flag = 2;
            this.data = res.data.data;
          } else {
            this.flag = 1;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async setCommonData(){
      this.tab_arr = [
        {
          name : await commonData('appShortName_11') + ' - ' + await commonData('appFullName_11'),
          index: 0,
        },{
          name : await commonData('appShortName_17') + ' - ' + await commonData('appFullName_17'),
          index: 1,
        },{
          name : await commonData('appShortName_37') + ' - ' + await commonData('appFullName_37'),
          index: 2,
        },{
          name : await commonData('appShortName_29') + ' - ' + await commonData('appFullName_29'),
          index: 3,
        },
      ]
    }
  },
  watch: {
    "$route.query.idx": {
      handler: function (newd) {
        this.changeTab(newd);
      },
    },
  },
  created() {
    this.changeTab(this.$route.query.idx);
    this.setCommonData()
  },
};
</script>
<style scoped>
.container {
  padding-top: 50px;
  height: 100%;
  min-height: 400px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=82)no-repeat top,url(../assets/img/bgonepp.jpg)repeat-y center top 900px;
  text-align: left;
}
.tab ul li {
  width: 228px;
}
/* .tab {
  width: 219px;
  z-index: 666;
  flex-shrink: 0;
}
.tab_title {
  font-size: 20px;
  font-weight: 570;
  line-height: 40px;
  padding-left: 8px;
  color: #323232;
  margin-top: 25px;
}
.underline {
  width: 30px;
  height: 2px;
  background: #323232;
  margin-left: 8px;
}
.tab ul {
  margin-top: 20px;
}
.tab ul li {
  color: #808080;
  height:48px;
  line-height: 48px;
  font-size: 16px;
  width: 210px;
  padding-left: 22px;
  background: transparent;
  cursor: pointer;
}
.tab ul li:hover{
  color: #3b78f7;
}
.tab ul li.active {
  color: #3b78f7;
  position: relative;
  background: url(../assets/img/active-left.png)no-repeat left center,url(../assets/img/active-v.png)no-repeat 125px center;
  background-size: auto,100% 100%;
}
.tab ul li.active::after {
  content: '';
  right: -20px;
  position: absolute;
  height: 100%;
  width: 30px;
  background: url(../assets/img/A.png)no-repeat center;
  background-size: 8px 12px;
} */
.content {
  color: #737373;
  border-radius: 10px  10px 0 0;
  width: 100%;
  height: 100%;
  min-height: 600px;
  /* margin-left: 40px; */
  background: #f6f9fe;
  box-shadow: -1px 0px 3px 0px rgba(209, 222, 238, 0.9);
  padding: 40px 71px;
  font-size: 17px;
}
.mt {
  background: rgb(224, 237, 254);
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}
.modeNm {
  padding-left: 12px;
  background-image: linear-gradient(
    to right,
    rgb(55, 146, 239),
    rgb(12, 184, 250)
  );
  height: 40px;
  line-height: 40px;
  display: inline-block;
  color: #fff;
}
.modeNm::after {
  content: "";
  display: inline-block;
  height: 40px;
  width: 16px;
  border-radius: 0% 100% 91% 9% / 100% 0% 100% 0%;
  position: absolute;
  background: rgb(12, 184, 250);
}
.text_indent {
  text-indent: 2em;
}
.model_box {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.model_box p {
  font-size: 15px;
  padding: 6px 0;
  color: rgb(132, 133, 135);
}
.box_text {
  /* width: 75%; */
}
.box_img {
  display: flex;
  margin-right: 25px;
}
.box_img img {
  align-self: center;
}
.p2 {
  color: rgb(118, 137, 163) !important;
}

.article {
  color: #838383;
  font-size: 15px;
}
.article p {
  /* line-height: 28px; */
}
.ar_tit {
  /* border-left: 4px solid #336ef0;
  padding-left: 6px; */
  font-size: 16px;
  height: 16px;
  line-height: 16px;
  font-weight: bold;
}
.look {
  width: 550px;
  margin: 60px auto;
  overflow: hidden;
  margin-bottom: 0px;
}

.uPic {
  background: url(../assets/img/wenhaol.png) no-repeat;
  background-position-y: 30px;
  width: 120px;
  height: 156px;
  float: left;
  /* margin-right: 20px; */
}

.lookInp {
  width: 380px;
  height: 44px;
  float: left;
  margin-top: 55px;
  overflow: hidden;
}

.kuang {
  width: 295px;
  height: 40px;
  border: 2px solid #6189c4;
  border-right: none;
  overflow: hidden;
  float: left;
}

.myInp {
  width: 93%;
  height: 100%;
  border: 0;
  outline: none;
  padding: 0 10px;
  font-size: 15px;
  color: #8d8d8d;
  *line-height: 40px;
  *height: 40px;
}
.myInp::-webkit-input-placeholder {
  color: #bdbdbd;
}
.myInp::-moz-placeholder {
  color: #bdbdbd;
}
.myInp:-ms-input-placeholder {
  color: #bdbdbd;
}
.myInp:-moz-placeholder {
  color: #bdbdbd;
}
.lookBtn {
  width: 65px;
  height: 44px;
  float: left;
  background: #6189c4;
  cursor: pointer;
}

.lookBtn i {
  display: block;
  background: url(../assets/img/lookbtn.jpg) no-repeat;
  width: 28px;
  height: 28px;
  margin: 8px 0 0 18px;
}
.out {
  width: 100%;
  margin-bottom: 30px;
  /* display: none; */
}

.conTitle,
.wcTitle {
  font-size: 24px;
  color: #3a84fd;
  font-weight: bold;
  margin-bottom: 40px;
}

.detailOut {
  width: 100%;
  position: relative;
}

.conDetail {
  padding-left: 10px;
  position: relative;
  overflow: hidden;
  margin-bottom: 40px;
}

.photo,
.nPro,
.pEmail {
  float: left;
  margin-right: 5px;
}

.photo {
  width: 70px;
  height: 70px;
  border-radius: 50px;
  overflow: hidden;
}

.photo img {
  width: 100%;
  height: 100%;
}

.nPro {
  /* width: 170px; */
}
.nPro .talk {
  margin-top: 10px;
}
.talk span {
  background: #f7eadc;
  color: #8d7c7c;
  height: 29px;
  line-height: 29px;
  vertical-align: middle;
  display: inline-block;
  padding-right: 8px;
  border-radius: 0 7px 7px 0;
}
.talk i {
  width: 14px;
  height: 29px;
  vertical-align: middle;
  display: inline-block;
  background: url(../assets/img/duihua.png) no-repeat;
}
.pname,
.ppro {
  font-size: 20px;
  font-weight: bold;
  margin: 10px;
}

.pEmail i {
  display: block;
  float: left;
  width: 29px;
  height: 28px;
  margin: 5px 12px 5px 0;
}

.phone,
.email {
  overflow: hidden;
  height: 35px;
  line-height: 38px;
}

.phone i {
  background: url(../assets/img/uphone.jpg) no-repeat;
}

.email i {
  background: url(../assets/img/email.jpg) no-repeat;
}

.pEmail span {
  font-size: 16px;
  font-weight: bold;
}

.compDet {
  width: 100%;
  background: #d3d3d3;
  padding: 15px 0;
}

.cDetail {
  margin-left: 98px;
}

.cDetail p {
  font-size: 15px;
  margin: 5px 0;
}

.cDetail .comName {
  font-size: 19px;
  font-weight: bold;
  margin-bottom: 10px;
}

.scanCode {
  position: absolute;
  right: 30px;
  top: 0;
  width: 174px;
  height: 210px;
  overflow: hidden;
}

.scPic {
  width: 166px;
  height: 166px;
  border: 4px solid #3a84ff;
  border-radius: 5px;
}

.scPic img {
  width: 100%;
  height: 100%;
}

.scTxt {
  width: 100%;
  text-align: center;
  font-size: 17px;
  margin-top: 8px;
  font-weight: 700;
}
.error_tips {
  color: rgb(131, 87, 88);
  font-size: 15px;
  width: 680px;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px dashed rgb(202, 202, 202);
  margin: 0 auto;
}
.content1 {
  width: 600px;
  margin: 0 auto;
  background: rgb(255, 252, 247);
  padding: 20px 40px;
}
.router-link-active {
  border: none;
}
</style>